import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import BarbaApp from './barba/BarbaApp';
import Header from './components/Header';
import Popup from './components/Popup';

export class FBN {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([FBN.domReady()]).then(() => this.init());
	}

	init() {
		new BarbaApp();
		new Header();
		new Popup();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new FBN();
